<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Setting</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-exam-setting @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <exam-setting-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExamSettingTable from '@/components/bosemexam/examsetting/Table/index'
import AddExamSetting from '@/components/bosemexam/examsetting/Forms/Add/index'

export default {
  components: {
    ExamSettingTable,
    AddExamSetting,
  },
  mounted: function() {
    this.getExamSetting()
    this.getSession()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      currentsession: null,
    }
  },
  methods: {
    getExamSetting: function() {
      this.loading = true
      this.$http.get('/api/exam/settings/all', {
        session_id: this.currentsession,
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    getSession() {
      this.$http.get('/api/session')
        .then(({ data }) => {
          // console.log(data.data)
          this.currentsession = data.data
          // this.currentsession = find(data.data, ['is_current', 1]).id
          // console.warn(this.currentsession.name)
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleCreated: function() {
      this.getExamSetting()
    },
    handleUpdateTable: function() {
      this.getExamSetting()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getExamSetting()
    },
    onChange(current) {
      this.current = current
      this.getExamSetting()
    },
  },
}
</script>
